import styled from "styled-components";
import ReactSlider from "react-slider";
import React, { useEffect } from "react";
import SliderIcon from "../../svg/SliderIcon";
import { useSelector } from "react-redux";
import { selectorGetSimulationSpeed } from "../../entities";

const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 25px;
  margin: 0 7px;
  position: absolute;
  z-index: 1;
  bottom: 1px;
  right: 12px;
  cursor: pointer;
`;

const StyledThumb = styled.div`
  top: 1px;
  width: 6px;
  height: 20px;
  // width: 10px;
  // height: 24px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  background: #fff;
  font-size: 7px;
  border: 4px solid #000;

  &:focus {
    outline: none;
  }
`;

const StyledTrack = styled.div`
  top: 9px;
  top: ${props => (props.index === 1 ? "13px" : "12px")};
  bottom: 0;
  background: ${props => (props.index === 1 ? "#333" : "#fff")};
  box-shadow: inset 1px 2px 4px rgba(0, 0, 0, 0.25);
  height: ${props => (props.index === 1 ? "2px" : "4px")};
  margin-right: 7px;
`;

const StyledBorder = styled.div`
  position: absolute;
  z-index: 0;
  background: #000;
  border-radius: 32px;
  height: 9px;
  width: 227px;
`;

const Thumb = (props, state) => <StyledThumb {...props}></StyledThumb>;

const Track = (props, state) => {
  return <StyledTrack {...props} index={state.index} />;
};

export default function Slider({ onChange }) {
  const event = new CustomEvent("resize", {
    detail: {},
    bubbles: true,
    cancelable: true
  });
  useEffect(() => {
    document.dispatchEvent(event);
  });
  const simulationSpeed = useSelector(selectorGetSimulationSpeed);

  return (
    <>
      <StyledSlider
        defaultValue={simulationSpeed}
        min={1}
        max={10}
        renderTrack={Track}
        renderThumb={Thumb}
        onChange={value => onChange(value)}
      />
      <StyledBorder />
    </>
  );
}
